import { css } from '@emotion/react'
// import { Alert } from '@mui/material'
import { memo } from 'react'
import { Message } from '../../../../../../types/mfc'
import Alert from '../../../../common/Alert'
import PMChatMessageClubShow from './PMChatMessageClubShow'
import PMChatNewsHeader from './PMChatNewsHeader'

const alertStyles = css({
    fontFamily: 'Montserrat, Helvetica, Arial, Sans-Serif !important',
    borderRadius: 16,
    width: '100%',
    maxWidth: 600,
    '& .alert-message': {
        width: '100%',
    },
})
const rootSystemPmStyles = css({
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: 12,
    display: 'flex',
    width: '100%',
    padding: 8,
})
const textStyles = css({
    padding: `0px 8px`,
    fontWeight: 500,
    fontSize: 12,
})

type PMChatSystemPMProps = {
    message: Message
    id: number
}

const PMChatSystemPM = memo((props: PMChatSystemPMProps) => {
    const { message, id } = props
    const { timestamp, clubShow, warning, success, error, text, from, news } =
        message

    const severity = success
        ? 'success'
        : error
          ? 'error'
          : warning
            ? 'warning'
            : 'info'
    return (
        <div css={rootSystemPmStyles} key={id}>
            <Alert
                css={alertStyles}
                severity={severity}
                icon={false}
                data-testid="Alert"
            >
                {!!clubShow && <PMChatMessageClubShow id={id} />}
                {!!news && (
                    <PMChatNewsHeader
                        timestamp={timestamp}
                        text={text}
                        id={from}
                    />
                )}
                {!!text && !clubShow && !news && (
                    <div
                        css={textStyles}
                        dangerouslySetInnerHTML={{
                            __html: text,
                        }}
                    />
                )}
            </Alert>
        </div>
    )
})

export default PMChatSystemPM
